import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// Auth Pages
import Login from './pages/auth/Login.vue'
import Register from './pages/auth/Register.vue'
import Verify from './pages/auth/Verify.vue'

// Info Pages
import Messages from './pages/info/Messages.vue'
import Rewards from './pages/info/Rewards.vue'
import Faq from './pages/info/Faq.vue'
import Contact from './pages/info/Contact.vue'
import About from './pages/info/About.vue'
import History from './pages/info/History.vue'

// App Pages
import Dashboard from './pages/app/Dashboard.vue'
import Profile from './pages/app/Profile.vue'
import Calendar from './pages/app/Calendar.vue'
import Preorder from './pages/app/Preorder.vue'
import Products from './pages/app/Products.vue'
import Checkout from './pages/app/Checkout.vue'
import Qrcode from './pages/app/Qrcode.vue'
import Wallet from './pages/app/Wallet.vue'
import Meetingroom from './pages/app/Meetingroom.vue'
import Today from './pages/app/Today.vue'

// Merchant Pages
import MerchantDashboard from './pages/merchant/Dashboard.vue'
import MerchantCheckout from './pages/merchant/Checkout.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/merchant',
      name: 'merchantDashboard',
      component: MerchantDashboard,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'MerchantLayout')
        next()
      }
    },
    {
      path: '/merchant/checkout',
      name: 'merchantCheckout',
      component: MerchantCheckout,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'MerchantLayout')
        next()
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/preorder/:date',
      name: 'preorder',
      component: Preorder,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/preorder/:date/:period',
      name: 'products',
      component: Products,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/qrcode',
      name: 'qrcode',
      component: Qrcode,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: Wallet,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/meetingroom',
      name: 'meetingroom',
      component: Meetingroom,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/today',
      name: 'today',
      component: Today,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AuthLayout')
        next()
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AuthLayout')
        next()
      }
    },
    {
      path: '/verify',
      name: 'verify',
      component: Verify,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AuthLayout')
        next()
      }
    },
    {
      path: '/messages',
      name: 'messages',
      component: Messages,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/rewards',
      name: 'rewards',
      component: Rewards,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    },
    {
      path: '/history',
      name: 'history',
      component: History,
      beforeEnter: function (to, from, next) {
        store.commit('SET_LAYOUT', 'AppLayout')
        next()
      }
    }
  ]
})
